import { FormattedMessage as BaseFormattedMessage } from '@olxpwa-lib/i18n/client';
import type { Messages } from '../types';

// TODO remove this once react-intl is upgraded to support FormatjsIntl.Message['ids']
type BaseProps = React.ComponentPropsWithoutRef<typeof BaseFormattedMessage>;
type Props = Omit<BaseProps, 'id'> & {
  id: Messages;
};

export const FormattedMessage = BaseFormattedMessage as React.ComponentType<Props>;
